module.exports = __webpack_public_path__ + "static/media/group.00b7a43b.jpg";